module.exports = "/_next/static/images/AggregationAudienceCreation-1bb5e76977d268ad807dc6d26f1c16ed.webp";